export default ({ linkName, disabled = false, linkUrl, description }) => (
  <>
    <h2 className="roboto" style={{ marginBottom: 0, marginTop: 30 }}>
      <a href={disabled ? '#' : linkUrl} className={disabled ? 'disabled' : ''}>
        {linkName}
      </a>
    </h2>
    {description ? <p>{description}</p> : null}
  </>
)
